export const GET_REPORTS_CANCELLATIONS_RESUME = 'providers/reports/Cancellations/GET_REPORTS_CANCELLATIONS_RESUME';
export const GET_REPORTS_CANCELLATIONS_DETAILS = 'providers/reports/Cancellations/GET_REPORTS_CANCELLATIONS_DETAILS';
export const GET_REPORTS_CANCELLATIONS_DETAILS_BY_PAGINATION =
  'providers/reports/Cancellations/GET_REPORTS_CANCELLATIONS_DETAILS_BY_PAGINATION';
export const GET_REPORTS_CANCELLATIONS_DETAILS_BY_SORTING =
  'providers/reports/Cancellations/GET_REPORTS_CANCELLATIONS_DETAILS_BY_SORTING';
export const EXPORT_REPORTS_CANCELLATIONS = 'providers/reports/Cancellations/EXPORT_REPORTS_CANCELLATIONS';
